var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 163,
    viewBox: "0 0 297 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_449_10690)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 297,
    height: 232,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.5196 204.035C2.80765 271.664 112.693 288.238 217.916 241.053C323.139 193.868 383.854 100.792 353.526 33.162C323.199 -34.4678 263.234 60.2811 158.012 107.466C52.7886 154.652 -57.8469 136.405 -27.5196 204.035Z",
    fill: "#4772F1",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.2209 205.011C2.61047 274.846 103.725 302.662 203.624 267.141C303.523 231.62 364.377 146.212 339.546 76.3765C314.714 6.5415 254.474 93.6773 154.575 129.199C54.676 164.72 -47.0523 135.176 -22.2209 205.011Z",
    fill: "#4772F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.186 198.051C219.859 265.681 123.354 288.255 34.6367 248.471C-54.0805 208.688 -101.415 121.612 -71.0876 53.9821C-40.7604 -13.6476 5.82379 75.1011 94.541 114.885C183.258 154.668 280.513 130.421 250.186 198.051Z",
    fill: "#873FE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.34 187.623C193.329 251.253 99.8043 265.373 22.446 219.161C-54.9123 172.95 -86.81 83.9058 -48.7995 20.2762C-10.789 -43.3534 20.1684 47.2645 97.5267 93.4761C174.885 139.688 269.35 123.993 231.34 187.623Z",
    fill: "#873FE2",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_10690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 297,
    height: 232,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDesign);
export default __webpack_public_path__ + "static/media/sidebarDesign.de60548569f9431f0fbc9857a663abad.svg";
export { ForwardRef as ReactComponent };